"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var keyvaluestorage_interface_1 = require("keyvaluestorage-interface");
exports.IKeyValueStorage = keyvaluestorage_interface_1.IKeyValueStorage;
//# sourceMappingURL=types.js.map